import { ApiClient } from "../ApiClient";

/**
 * Update account data
 * @param {Object} data - The account data to update
 * @returns {Promise<Response>} API response (Raw Response preserved)
 */
export const updateAccount = async (data) => {
  // ApiClient.put handles baseUrl, CSRF, and JSON stringification
  // We wrap data in { values: data } to match your backend's expected structure
  return ApiClient.put("/account/update-account", {
    values: data,
  });
};

/**
 * Update account avatar
 * Note: This maintains the original behavior of returning the parsed JSON object
 * and throwing a manual error on failure.
 * @param {File} file - The avatar file to upload
 * @returns {Promise<Object>} API response with avatar data (Parsed JSON)
 */
export const updateSettingsAvatar = async (file) => {
  const formData = new FormData();
  formData.append("setting", "Avatar");
  formData.append(
    "values",
    JSON.stringify({ avatar: file.name, filetype: file.type }),
  );
  formData.append("avatar", file);

  // ApiClient handles FormData (removes JSON content-type automatically)
  const response = await ApiClient.put("/account/account-settings", formData);

  if (response.ok) {
    // Parity: Returns the parsed result as the original did
    return await response.json();
  } else {
    // Parity: Original code logged the error and threw a specific Error object
    console.error("API error response:", response.status, response.statusText);
    throw new Error("Avatar upload failed");
  }
};
